import { IPromotionLogicInterface } from '@gongxigames/framework/promotions';
import { PromotionDecision } from '@gongxigames/framework/integrations/rubyplay/types';

export interface IMultiSetsMulticampaignPromotionInterface extends IPromotionLogicInterface {
    setChoice(choice: PromotionDecision, succeessCB: () => void, failureCB: () => void): void;
    end(): void;
    getExpirationTime(): string;
    getRulesUrl(): string;
    endExpiredRounds(): void;
}
